import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SignatureDishes } from './components/SignatureDishes';
import { MenusSection } from './components/MenusSection';
import { AtmosphereSection } from './components/AtmosphereSection';
import { GallerySection } from './components/GallerySection';
import { ReviewsSection } from './components/ReviewsSection';
import { LocationSection } from './components/LocationSection';
import { ContactReservation } from './components/ContactReservation';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Add smooth scrolling to html element
    document.documentElement.style.scrollBehavior = 'smooth';
    // Set document title
    document.title = 'The Old Mill Restaurant | Temple Bar Dublin | Traditional Irish Food';
    // Add meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Traditional Irish dishes in Temple Bar, Dublin 2. Breakfast to dinner, full bar, walk-ins welcome. Call +353 1 671 9266.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Traditional Irish dishes in Temple Bar, Dublin 2. Breakfast to dinner, full bar, walk-ins welcome. Call +353 1 671 9266.';
      document.head.appendChild(meta);
    }
    // Add JSON-LD Schema
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Restaurant',
      name: 'The Old Mill Restaurant',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '14 Temple Bar Square',
        addressLocality: 'Dublin 2',
        addressCountry: 'IE'
      },
      telephone: '+353 1 671 9266',
      email: 'info@oldmillrestaurant.ie',
      url: 'https://oldmillrestaurant.ie/',
      openingHours: 'Mo-Su 09:00-22:30',
      servesCuisine: 'Irish',
      priceRange: '€€'
    });
    document.head.appendChild(schemaScript);
    return () => {
      document.documentElement.style.scrollBehavior = '';
      if (document.head.contains(schemaScript)) {
        document.head.removeChild(schemaScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-background text-foreground font-sans selection:bg-primary/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SignatureDishes data-id="element-4" />
        <MenusSection data-id="element-5" />
        <AtmosphereSection data-id="element-6" />
        <GallerySection data-id="element-7" />
        <ReviewsSection data-id="element-8" />
        <LocationSection data-id="element-9" />
        <ContactReservation data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}